<template>
  <div class="login-page">
    <!-- Animated Background -->
    <div class="background-layer">
      <div class="grid-overlay"></div>
      <div class="gradient-orb orb1"></div>
      <div class="gradient-orb orb2"></div>
      <div class="gradient-orb orb3"></div>
    </div>

    <!-- Login Container -->
    <div class="login-container">
      <div class="login-card">
        <!-- Logo Section -->
        <div class="logo-section">
          <div class="logo-wrapper">
            <img
              src="../assets/images/logo.jpg"
              alt="Logo"
              class="logo-image"
            />
          </div>
          <h1 class="app-title">ເຂົ້າສູ່ລະບົບ</h1>
          <p class="app-subtitle">ເຂົ້າສູ່ລະບົບບັນຊີຂອງທ່ານຢ່າງປອດໄພ</p>
        </div>

        <!-- Login Form -->
        <form @submit.prevent="login" class="login-form">
          <!-- Phone Input -->
          <div class="form-group">
            <label class="form-label">ເບີໂທ</label>
            <div class="input-wrapper">
              <span class="input-icon">
                <i class="fas fa-phone"></i>
              </span>
              <input
                type="text"
                class="form-input"
                v-model="phone"
                placeholder="ກະລຸນາໃສ່ເບີໂທລະສັບ"
                required
              />
            </div>
          </div>

          <!-- Password Input -->
          <div class="form-group">
            <label class="form-label">ລະຫັດຜ່ານ</label>
            <div class="input-wrapper">
              <span class="input-icon">
                <i class="fas fa-lock"></i>
              </span>
              <input
                :type="passwordVisible ? 'text' : 'password'"
                class="form-input"
                v-model="password"
                placeholder="********"
                required
              />
              <button
                type="button"
                class="toggle-password"
                @click="togglePasswordVisibility"
                tabindex="-1"
              >
                <i
                  :class="passwordVisible ? 'fas fa-eye-slash' : 'fas fa-eye'"
                ></i>
              </button>
            </div>
          </div>

          <!-- Remember & Forgot -->
          <div class="form-options">
            <label class="remember-me">
              <input type="checkbox" v-model="rememberMe" />
              <span>ຈື່ໄວ້</span>
            </label>
            <a href="#" class="forgot-password">ລືມລະຫັດຜ່ານ？</a>
          </div>

          <!-- Error Message -->
          <div v-if="error" class="error-message">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{ error }}</span>
          </div>

          <!-- Submit Button -->
          <button type="submit" class="submit-button" :disabled="loading">
            <span v-if="!loading">
              <i class="fas fa-sign-in-alt mx-1"></i>ເຂົ້າສູ່ລະບົບ
            </span>
            <span v-else class="loading-spinner">
              <i class="fas fa-spinner fa-spin"></i>
              登录中...
            </span>
          </button>
        </form>

        <!-- Footer -->
        <div class="login-footer">
          <p>ມີບັນຊີແລ້ວບໍ？ <a href="#" class="register-link">ລົງທະບຽນ</a></p>
        </div>
      </div>

      <!-- Info Panel (Optional) -->
      <div class="info-panel">
        <div class="info-content">
          <div class="feature-item" data-delay="0">
            <div class="feature-icon">
              <i class="fas fa-shield-alt"></i>
              <div class="icon-glow"></div>
            </div>
            <h3>ປອດໄພ ແລະ ເຊື່ອຖືໄດ້</h3>
            <p>ການເຂົ້າລະຫັດລະດັບທະນາຄານປົກປ້ອງຂໍ້ມູນທາງການເງິນຂອງທ່ານ</p>
          </div>
          <div class="feature-item" data-delay="1">
            <div class="feature-icon">
              <i class="fas fa-chart-line"></i>
              <div class="icon-glow"></div>
            </div>
            <h3>ການວິເຄາະອັດສະລິຍະ</h3>
            <p>ຕິດຕາມ ແລະ ວິເຄາະການເງິນຂອງທ່ານໄດ້ທັນທີ</p>
          </div>
          <div class="feature-item" data-delay="2">
            <div class="feature-icon">
              <i class="fas fa-mobile-alt"></i>
              <div class="icon-glow"></div>
            </div>
            <h3>ທຸກເວລາ, ທຸກບ່ອນ</h3>
            <p>ການເຂົ້າເຖິງຂ້າມແພລດຟອມເພື່ອການຄຸ້ມຄອງທີ່ງ່າຍຂຶ້ນ</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<!-- dd -->
<script>
import Swal from "sweetalert2";
import axios from "axios";
import { authState } from "../auth";

export default {
  name: "LoginComponent",
  data() {
    return {
      phone: "",
      password: "",
      error: null,
      passwordVisible: false, // State to track password visibility
    };
  },
  methods: {
    async login() {
      try {
        const response = await axios.post(
          "https://nodejs-api-daily-porchoua-4.onrender.com/login",
          {
            phone: this.phone,
            password: this.password,
          }
        );

        if (response.data.error) {
          this.error = response.data.message;
        } else {
          this.error = null;
          // Update authentication state
          authState.isAuthenticated = true;
          authState.user = response.data.user;
          // Redirect to dashboard
          this.showWelcomeMessage();
          this.$router.push("/dashboard");
        }
      } catch (error) {
        this.showErrorMessage();
      }
    },
    togglePasswordVisibility() {
      this.passwordVisible = !this.passwordVisible; // Toggle the visibility state
    },
    async showWelcomeMessage() {
      Swal.fire({
        title: "欢迎",
        text: "登陆财务管理系统",
        icon: "success",
        timer: 2000,
        position: "top-end",
        toast: true,
        showConfirmButton: false,
      });
    },
    async showErrorMessage() {
      Swal.fire({
        title: "出错",
        text: "请从事!",
        icon: "warning",
        timer: 2000,
        position: "top-end",
        toast: true,
        showConfirmButton: false,
      });
    },
  },
};
</script>

<style scoped>
/* Base Styles */
.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Noto Sans",
    sans-serif;
  padding: 20px;
}

/* Animated Background */
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #0f172a 100%);
  z-index: 0;
}

.grid-overlay {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: linear-gradient(
      rgba(148, 163, 184, 0.03) 1px,
      transparent 1px
    ),
    linear-gradient(90deg, rgba(148, 163, 184, 0.03) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: gridMove 20s linear infinite;
}

@keyframes gridMove {
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(50px, 50px);
  }
}

.gradient-orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.3;
  animation: float 15s ease-in-out infinite;
}

.orb1 {
  width: 600px;
  height: 600px;
  background: radial-gradient(
    circle,
    rgba(84, 195, 146, 0.4) 0%,
    transparent 70%
  );
  top: -15%;
  left: -10%;
}

.orb2 {
  width: 500px;
  height: 500px;
  background: radial-gradient(
    circle,
    rgba(59, 130, 246, 0.4) 0%,
    transparent 70%
  );
  bottom: -10%;
  right: -10%;
  animation-delay: 3s;
}

.orb3 {
  width: 400px;
  height: 400px;
  background: radial-gradient(
    circle,
    rgba(168, 85, 247, 0.3) 0%,
    transparent 70%
  );
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  animation-delay: 6s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(30px, -30px) scale(1.1);
  }
  66% {
    transform: translate(-20px, 20px) scale(0.9);
  }
}

/* Login Container */
.login-container {
  position: relative;
  z-index: 10;
  display: flex;
  gap: 40px;
  max-width: 1200px;
  width: 100%;
  align-items: center;
}

/* Login Card */
.login-card {
  background: rgba(30, 41, 59, 0.7);
  backdrop-filter: blur(20px);
  border: 1px solid rgba(148, 163, 184, 0.1);
  border-radius: 24px;
  padding: 48px;
  width: 100%;
  max-width: 480px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.4);
  animation: slideInLeft 0.6s ease-out;
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-30px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Logo Section */
.logo-section {
  text-align: center;
  margin-bottom: 40px;
}

.logo-wrapper {
  display: inline-block;
  margin-bottom: 20px;
  position: relative;
}

.logo-image {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  object-fit: cover;
  border: 3px solid rgba(84, 195, 146, 0.3);
  box-shadow: 0 0 30px rgba(84, 195, 146, 0.2);
  transition: transform 0.3s ease;
}

.logo-wrapper:hover .logo-image {
  transform: scale(1.05);
}

.app-title {
  font-size: 32px;
  font-weight: 700;
  margin: 0 0 8px 0;
  background: linear-gradient(135deg, #54c392, #3b82f6);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.app-subtitle {
  font-size: 14px;
  color: #94a3b8;
  margin: 0;
}

/* Form Styles */
.login-form {
  margin-bottom: 24px;
}

.form-group {
  margin-bottom: 24px;
}

.form-label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #e2e8f0;
  margin-bottom: 8px;
}

.input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.input-icon {
  position: absolute;
  left: 16px;
  color: #64748b;
  font-size: 16px;
  z-index: 1;
  transition: color 0.3s ease;
}

.form-input {
  width: 100%;
  padding: 14px 16px 14px 48px;
  background: rgba(15, 23, 42, 0.5);
  border: 1px solid rgba(148, 163, 184, 0.2);
  border-radius: 12px;
  color: #e2e8f0;
  font-size: 15px;
  transition: all 0.3s ease;
  outline: none;
}

.form-input::placeholder {
  color: #64748b;
}

.form-input:focus {
  background: rgba(15, 23, 42, 0.7);
  border-color: #54c392;
  box-shadow: 0 0 0 3px rgba(84, 195, 146, 0.1);
}

.form-input:focus + .toggle-password,
.form-input:focus ~ .input-icon {
  color: #54c392;
}

.toggle-password {
  position: absolute;
  right: 16px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 8px;
  transition: color 0.3s ease;
  outline: none;
}

.toggle-password:hover {
  color: #54c392;
}

/* Form Options */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  font-size: 14px;
}

.remember-me {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #94a3b8;
  cursor: pointer;
  margin: 0;
}

.remember-me input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
  accent-color: #54c392;
}

.forgot-password {
  color: #54c392;
  text-decoration: none;
  transition: color 0.3s ease;
}

.forgot-password:hover {
  color: #3da876;
}

/* Error Message */
.error-message {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 8px;
  color: #fca5a5;
  font-size: 14px;
  margin-bottom: 20px;
  animation: shake 0.5s ease;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-10px);
  }
  75% {
    transform: translateX(10px);
  }
}

/* Submit Button */
.submit-button {
  width: 100%;
  padding: 14px 24px;
  background: linear-gradient(135deg, #54c392, #3da876);
  border: none;
  border-radius: 12px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(84, 195, 146, 0.3);
}

.submit-button:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(84, 195, 146, 0.4);
}

.submit-button:active:not(:disabled) {
  transform: translateY(0);
}

.submit-button:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.loading-spinner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Footer */
.login-footer {
  text-align: center;
  padding-top: 24px;
  border-top: 1px solid rgba(148, 163, 184, 0.1);
  color: #94a3b8;
  font-size: 14px;
}

.register-link {
  color: #54c392;
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.register-link:hover {
  color: #3da876;
}

/* Info Panel */
.info-panel {
  flex: 1;
  max-width: 500px;
}

.info-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.feature-item {
  display: flex;
  flex-direction: column;
  gap: 12px;
  opacity: 0;
  transform: translateX(50px);
  animation: slideInFeature 0.6s ease-out forwards;
  cursor: pointer;
  padding: 20px;
  border-radius: 16px;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: transparent;
}

.feature-item[data-delay="0"] {
  animation-delay: 0.3s;
}

.feature-item[data-delay="1"] {
  animation-delay: 0.5s;
}

.feature-item[data-delay="2"] {
  animation-delay: 0.7s;
}

@keyframes slideInFeature {
  from {
    opacity: 0;
    transform: translateX(50px) translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0) translateY(0);
  }
}

.feature-item:hover {
  transform: translateX(15px) scale(1.02);
  background: rgba(30, 41, 59, 0.3);
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
}

.feature-item:hover .feature-icon {
  transform: scale(1.1) rotate(5deg);
  background: linear-gradient(
    135deg,
    rgba(34, 197, 94, 0.2),
    rgba(59, 130, 246, 0.2)
  );
  box-shadow: 0 8px 24px rgba(34, 197, 94, 0.3);
}

.feature-item:hover .icon-glow {
  opacity: 1;
  transform: scale(1.5);
}

.feature-item:hover h3 {
  color: #22c55e;
  transform: translateX(5px);
}

.feature-item:hover p {
  color: #cbd5e1;
}

.feature-icon {
  width: 56px;
  height: 56px;
  border-radius: 16px;
  background: linear-gradient(
    135deg,
    rgba(34, 197, 94, 0.1),
    rgba(59, 130, 246, 0.1)
  );
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: #22c55e;
  position: relative;
  overflow: hidden;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  animation: iconPulse 2s ease-in-out infinite;
}

.feature-item[data-delay="0"] .feature-icon {
  animation-delay: 0s;
}

.feature-item[data-delay="1"] .feature-icon {
  animation-delay: 0.7s;
}

.feature-item[data-delay="2"] .feature-icon {
  animation-delay: 1.4s;
}

@keyframes iconPulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(34, 197, 94, 0.4);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(34, 197, 94, 0);
  }
}

.feature-icon i {
  position: relative;
  z-index: 2;
  animation: iconFloat 3s ease-in-out infinite;
}

@keyframes iconFloat {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

.icon-glow {
  position: absolute;
  width: 100%;
  height: 100%;
  background: radial-gradient(
    circle,
    rgba(34, 197, 94, 0.6) 0%,
    transparent 70%
  );
  opacity: 0;
  transition: all 0.4s ease;
  z-index: 1;
}

.feature-item h3 {
  font-size: 20px;
  font-weight: 600;
  color: #e2e8f0;
  margin: 0;
  transition: all 0.3s ease;
}

.feature-item p {
  font-size: 15px;
  color: #94a3b8;
  margin: 0;
  line-height: 1.6;
  transition: color 0.3s ease;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .info-panel {
    display: none;
  }

  .login-container {
    justify-content: center;
  }
}

@media (max-width: 640px) {
  .login-card {
    padding: 32px 24px;
  }

  .app-title {
    font-size: 28px;
  }

  .logo-image {
    width: 70px;
    height: 70px;
  }
}
</style>
